<script lang="ts">
  import type { AfterState } from '@pin/schemas/client-state-response';
  import { onMount } from 'svelte';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';
  import { getItem } from '../util/storage';
  import { getSubmittedVotesKey } from '../util/votesKeys';
  export let pollData: AfterState;

  $: didVote = !!getItem('local', getSubmittedVotesKey(pollData.id));

  onMount(() => {
    trackEvent(
      { action: 'state:after-poll', label: pollData.title },
      pollData.id
    );
  });
</script>

<!-- svelte-ignore a11y-autofocus -->
<div class="wrapper">
  <h2 autofocus tabindex="-1">{i18n('poll.after')}</h2>
  {#if didVote}
    <p>{i18n('poll.after-thanks')}</p>
  {/if}
</div>

<style>
  .wrapper {
    margin: 1rem 0 2rem;
    text-align: center;
  }
</style>
